import { eBaoCaoThongKeActionsObj } from "../../action-types/bao-cao-thong-ke/IBaoCaoThongKeActions";
import { generateActions } from "../generateActions";

export const baoCaoThongKeActions = {
    ...generateActions(eBaoCaoThongKeActionsObj, "BAO_CAO_THONG_KE"),
}